module.exports = __webpack_public_path__ + "img/profile.4809215c.svg";